import { Avatar, Table } from '@mantine/core';
import { useLocation } from 'react-router';
import formatDate from '../../constants/formattedDate';
import prettifiedLabel from '../../constants/labelPrettifier';

const ProductRows = ({ products }) => {
  const location = useLocation();

  return products.map((product, i) => {
    return (
      <Table.Tr key={i} data-tour="selectProduct">
        <Table.Td>{product.id}</Table.Td>
        <Table.Td>
          <Avatar
            size={50}
            src={product.imageUrl}
            alt="Product Image"
            radius="xl"
            style={{ display: 'inline-block', verticalAlign: 'middle' }}
          />
          &nbsp;&nbsp;
          <a href={`#${location.pathname}/${product.id}`}>
            <strong>{product.name}</strong>
          </a>
        </Table.Td>
        <Table.Td>{prettifiedLabel(`${product.available}`)}</Table.Td>
        <Table.Td>{product.locale}</Table.Td>
        <Table.Td>
          {product.listPrice?.toLocaleString(navigator.language, { style: 'currency', currency: product.currency })}
        </Table.Td>
        <Table.Td>{product.price?.toLocaleString(navigator.language, { style: 'currency', currency: product.currency })}</Table.Td>
        <Table.Td>{product.discountPercent ? `${Math.round(product.discountPercent)}%` : null}</Table.Td>
        <Table.Td>{formatDate(product.createdAt)}</Table.Td>
        <Table.Td>{formatDate(product.updatedAt)}</Table.Td>
        <Table.Td>{product.popularScoreByProductView}</Table.Td>
        <Table.Td>{product.popularScoreByCartAdd}</Table.Td>
      </Table.Tr>
    );
  });
};

export default ProductRows;
